/* eslint-disable react/no-string-refs */
/* eslint-disable react/no-find-dom-node */

/*
 * Copyright 2015 Pablo Fierro (https://github.com/pablofierro/react-drag-select)
 *
 * Permission to use, copy, modify, and/or distribute this software for any
 * purpose with or without fee is hereby granted, provided that the above
 * copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
 * REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
 * AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
 * INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
 * LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
 * OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
 * PERFORMANCE OF THIS SOFTWARE.
 */

import noop from 'lodash.noop';
import keys from 'lodash.keys';
import has from 'lodash.has';
import forEach from 'lodash.foreach';
import isNull from 'lodash.isnull';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import propTypes from 'prop-types';

import './Selection.scss';

export default class Selection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mouseDown: false,
      startPoint: null,
      endPoint: null,
      selectionBox: null,
      selectedItems: {},
      appendMode: false,
    };
  }

  /**
   * On componentn mount
   */
  componentWillMount() {
    this.selectedChildren = {};
  }

  /**
   * On component props change
   */
  componentWillReceiveProps(nextProps) {
    var _this2 = this;

    var nextState = {};
    if (!nextProps.enabled) {
      nextState.selectedItems = {};
    }
    this.setState(nextState);

    this.selectedChildren = {};
    if (nextProps.selectedList) {
      nextProps.selectedList.map(function(item) {
        _this2.selectedChildren[item] = true;
      });
    }
  }

  /**
   * On component update
   */
  componentDidUpdate() {
    if (this.state.mouseDown && !isNull(this.state.selectionBox)) {
      this._updateCollidingChildren(this.state.selectionBox);
    }
  }

  /**
   * On root element mouse down
   */
  _onMouseDown = e => {
    if (!this.props.enabled || e.button === 2 || e.nativeEvent.which === 2) {
      return;
    }
    var nextState = {};
    if (e.ctrlKey || e.altKey || e.shiftKey) {
      nextState.appendMode = true;
    }
    nextState.mouseDown = true;

    var parentNode = ReactDOM.findDOMNode(this.refs.selectionBox);
    var scrollY = Math.abs(
      parentNode.getClientRects()[0].top - this.cumulativeOffset(parentNode).top
    );
    var scrollX = Math.abs(
      parentNode.getClientRects()[0].left - this.cumulativeOffset(parentNode).left
    );
    nextState.startPoint = {
      x: e.clientX - this.cumulativeOffset(parentNode).left + scrollX,
      y: e.clientY - this.cumulativeOffset(parentNode).top + scrollY,
    };
    this.setState(nextState);
    window.document.addEventListener('mousemove', this._onMouseMove);
    window.document.addEventListener('mouseup', this._onMouseUp);
  };

  /**
   * On document element mouse up
   */
  _onMouseUp = () => {
    window.document.removeEventListener('mousemove', this._onMouseMove);
    window.document.removeEventListener('mouseup', this._onMouseUp);
    this.setState({
      mouseDown: false,
      startPoint: null,
      endPoint: null,
      selectionBox: null,
      appendMode: false,
    });
    this.props.onSelectionChange.call(null, keys(this.selectedChildren));
  };

  /**
   * On document element mouse move
   */
  _onMouseMove = e => {
    // e.preventDefault();
    if (this.state.mouseDown) {
      var parentNode = ReactDOM.findDOMNode(this.refs.selectionBox);
      var scrollY = Math.abs(
        parentNode.getClientRects()[0].top - this.cumulativeOffset(parentNode).top
      );
      var scrollX = Math.abs(
        parentNode.getClientRects()[0].left - this.cumulativeOffset(parentNode).left
      );
      var endPoint = {
        x: e.clientX - this.cumulativeOffset(parentNode).left + scrollX,
        y: e.clientY - this.cumulativeOffset(parentNode).top + scrollY,
      };
      if (e.clientY < endPoint.y) {
        parentNode.scrollTop -= 5;
      }
      this.setState({
        endPoint: endPoint,
        selectionBox: this._calculateSelectionBox(this.state.startPoint, endPoint),
      });
      return false;
    }
  };

  /**
   * Render
   */
  render() {
    var className = 'selection ' + (this.state.mouseDown ? 'dragging' : '');
    return React.createElement(
      'div',
      {
        className: className,
        ref: 'selectionBox',
        onMouseDown: this._onMouseDown,
      },
      this.renderChildren(),
      this.renderSelectionBox()
    );
  }

  /**
   * Render children
   */
  renderChildren() {
    var index = 0;
    var _this = this;
    var tmpChild;
    return React.Children.map(this.props.children, function(child, actualIndex) {
      var tmpKey = isNull(child.key) ? index++ : child.key;
      var isSelected = has(_this.selectedChildren, actualIndex);
      tmpChild = React.cloneElement(child, {
        ref: tmpKey,
        selectionParent: _this,
        isSelected: isSelected,
      });

      var onClickCapture = function onClickCapture(e) {
        if ((e.ctrlKey || e.altKey || e.shiftKey) && _this.props.enabled) {
          e.preventDefault();
          e.stopPropagation();
          _this.selectItem(tmpKey, !has(_this.selectedChildren, tmpKey));
        }
      };

      return (
        <div
          style={isSelected ? _this.props.itemSelectedStyle : _this.props.itemStyle}
          className={_this.props.itemClassName + ' select-box ' + (isSelected ? 'selected' : '')}
          onClickCapture={onClickCapture}
        >
          {tmpChild}
        </div>
      );
    });
  }

  /**
   * Render selection box
   */
  renderSelectionBox() {
    if (!this.state.mouseDown || isNull(this.state.endPoint) || isNull(this.state.startPoint)) {
      return null;
    }
    return React.createElement('div', {
      className: 'selection-border',
      style: this.state.selectionBox,
    });
  }

  /**
   * Manually update the selection status of an item
   * @param {string} key the item's target key value
   * @param {boolean} isSelected the item's target selection status
   */
  selectItem(key, isSelected) {
    if (isSelected) {
      this.selectedChildren[key] = isSelected;
    } else {
      delete this.selectedChildren[key];
    }
    this.props.onSelectionChange.call(null, keys(this.selectedChildren));
    this.forceUpdate();
  }

  /**
   * Select all items
   */
  selectAll() {
    forEach(
      this.refs,
      function(ref, key) {
        if (key !== 'selectionBox') {
          this.selectedChildren[key] = true;
        }
      }.bind(this)
    );
    this.props.onSelectionChange.call(null, []);
    this.forceUpdate();
  }

  /**
   * Manually clear selected items
   */
  clearSelection() {
    this.selectedChildren = {};
    this.props.onSelectionChange.call(null, []);
    this.forceUpdate();
  }

  /**
   * Detect 2D box intersection
   */
  _boxIntersects(boxA, boxB) {
    if (
      boxA.left <= boxB.left + boxB.width &&
      boxA.left + boxA.width >= boxB.left &&
      boxA.top <= boxB.top + boxB.height &&
      boxA.top + boxA.height >= boxB.top
    ) {
      return true;
    }
    return false;
  }

  /**
   * Updates the selected items based on the
   * collisions with selectionBox
   */
  _updateCollidingChildren(selectionBox) {
    var tmpBox = null;
    var _this = this;
    forEach(
      ReactDOM.findDOMNode(this.refs.selectionBox).querySelectorAll('.timeslot-division'),
      function(tmpNode, key) {
        tmpBox = {
          top: tmpNode.offsetTop,
          left: tmpNode.offsetLeft,
          width: tmpNode.clientWidth,
          height: tmpNode.clientHeight,
        };
        if (_this._boxIntersects(selectionBox, tmpBox)) {
          _this.selectedChildren[key] = true;
        } else {
          if (!_this.state.appendMode) {
            delete _this.selectedChildren[key];
          }
        }
      }
    );
  }

  /**
   * Calculate selection box dimensions
   */
  _calculateSelectionBox(startPoint, endPoint) {
    if (!this.state.mouseDown || isNull(endPoint) || isNull(startPoint)) {
      return null;
    }
    var parentNode = ReactDOM.findDOMNode(this.refs.selectionBox);
    var left = Math.min(startPoint.x, endPoint.x) - parentNode.offsetLeft;
    var top = Math.min(startPoint.y, endPoint.y) - parentNode.offsetTop;
    var width = Math.abs(startPoint.x - endPoint.x);
    var height = Math.abs(startPoint.y - endPoint.y);
    return {
      left: left,
      top: top,
      width: width,
      height: height,
    };
  }

  cumulativeOffset(element) {
    var top = 0,
      left = 0;
    do {
      top += element.offsetTop || 0;
      left += element.offsetLeft || 0;
      element = element.offsetParent;
    } while (element);

    return {
      top: top,
      left: left,
    };
  }
}

Selection.propTypes = {
  enabled: propTypes.bool,
  onSelectionChange: propTypes.func,
  selectedList: propTypes.array,
  children: propTypes.node,
};

/**
 * Component default props
 */
Selection.defaultProps = {
  enabled: true,
  onSelectionChange: noop,
  selectedList: [],
};
